export default __webpack_public_path__ + "static/zipacon-898acdd6cb7636d9c3b0811778bca148.png";